export default __webpack_public_path__ + "static/media/Snd_C4.dcf180fe.mp3";